<template>
  <div id="file-info" class="listStyle">
    <van-popup
      v-model="showDetailPopup"
      :style="{ height: '100%', width: '100%' }"
    >
      <audio id="video-player" :src="audioLink" style="visibility:hidden">
        您的浏览器不支持audio元素。
      </audio>
      <Speecher
        ref="speech"
        :speechPause="speechPause"
        @playAudio="playAudio"
        @pauseAudio="pauseAudio"
        @resetAudio="resetAudio">
      </Speecher>
      <!-- 弹框详情 -->
      <template v-if="value && headers.length != 0">
        <div class="fileElements">
          <div class="docContent" id="moreMerchant">
            <van-collapse v-model="activeNames">
              <van-collapse-item title="文件要素" name="1">
                <div class="elements topLine">
                  <div class="title">文件要素</div>
                  <div class="content">内容</div>
                </div>
                <div
                  class="elements"
                  v-for="(item, index) in headers"
                  :key="index"
                >
                  <div class="title" v-html="item.t"></div>
                  <div class="content" v-html="item.v" @click="openLink"></div>
                </div>
              </van-collapse-item>
            </van-collapse>
            <div
              class="detail defaultFont"
              v-html="value"
              style="background: #fff; padding: 10px"
              @click="openLink"
            ></div>
            <div v-if="!userId && !wxgenerateid" class="loginBtn">
              <van-button type="primary" @click="login">登录/注册</van-button>
            </div>
          </div>
        </div>
        <van-tabbar :border="false">
          <div
            class="backStyle"
            style="
              background-color: #fff;
              diaplay: flex;
              justify-content: space-around;
              align-items: center;
            "
          >

            <div class="oprate-box"
                @click="backToLastFire">
              <van-image width="16" height="16" :src="lastFlag ? returnImgUn: returnImg" />
              <span class="custom-title" :class="lastFlag? 'no-return': ''">
                返回</span>
            </div>
            <div class="oprate-box" @click="backToMail">
              <van-image width="16" height="16" :src="closeImg" />
              <span class="custom-title">关闭</span>
            </div>
            <div class="oprate-box" @click="showMailPop = true">
              <van-image width="16" height="13" :src="mailImg" />
              <span class="custom-title">邮箱</span>
            </div>
            <div class="oprate-box" 
                v-if="activeName !== 'c'"
                @click="uploadToSmartCloud">
              <van-image width="22" height="15" :src="cloudImg" />
              <span class="custom-title">上传云端</span>
            </div>
            <van-button
              :icon="shareImg"
              class="share-btn"
              @click="shareBtn"
              >分享
            </van-button>
          </div>
        </van-tabbar>
      </template>
    </van-popup>
    
    <van-popup
      v-model="showMailPop"
      position="bottom"
      closeable
      round
      style="width:100%; height:40%"
    >
      <div class="send-mail-wapper">
        <h3 style="text-align:center">发送文件到邮箱</h3>
        <div class="mail-box">
          <span>邮箱:</span>
          <van-field
            v-model="mailText"
            placeholder="请输入您的邮箱"
            :error-message="errMsg.mailText"
          />
        </div>
        <van-button
          :disabled="!mailText"
          style="width:100%;border-radius: 30px;height: 40px;"
          type="info"
          @click="sureSendMail"
          >确定</van-button
        >
      </div>
    </van-popup>
    <!-- dialog -->
    <!-- <van-overlay
      :show="showLoding"
      @click="showLoding = false"
      z-index="9999"
      :custom-style="{ backgroundColor: 'rgba(255, 255, 255, .8)' }"
    >
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#1989fa"></van-loading>
      </div>
    </van-overlay> -->
    <!-- 登录 -->
    <!-- <login ref="alertModel" @updateDoc="updateDoc"></login> -->

    
    <!-- 一键上传 -->
    <upload-file v-if="showUpload" :uploadDocId="uploadDocId" ref="uploadFile">
    </upload-file>

    <!-- 初次进入页面未加载成功数据时显示loading -->
    <van-overlay
      :show="!value && headers.length == []"
      z-index="100"
      :custom-style="{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }"
      >
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import UploadFile from "@/components/common/uploadFile"; // 一键上传
import Speecher from "@/components/speecher"; // 一键上传
import baseConfig from "../../../public/config.json";
import { commonNotify, warningNotify } from "../../utils/lib/toast";
import { base } from "@/utils/lib/util.js";
import Login from "@/components/common/login";
import { searchToObj, getUrlParam } from "@/utils/lib/searchtoobj.js";
import { fileInfoUrl } from "../../../public/config.json";
import { getTempLocation } from "@/utils/lib/tempLogin.js"; // 临时登录
import { wxConfig } from "@/utils/newLibs/getWxOptions.js";
export default {
  data() {
    return {
      headers: [], // 文件要素
      value: "", // 文件正文内容
      activeNames: ["1"],
      strId: "TMz",
      lastFlag: true, // 是否显示可点击返回按钮
      addid: true, // 为true的时候添加id进数组
      backDocFiresArr: [], // 返回的文件docid
      showLoding: false, // 是否显示加载
      uploadDocId: [],
      showLoginBtn: false,
      shareLink: '', // 分享链接
      showUpload: false,
      shareType: 0, //分享的文件类型
      shareTitle: '', //分享的文件标题
      shareScene: '', //分享场景
      returnImg: require("../../assets/index/return_img.png"),
      returnImgUn: require("../../assets/index/return_un_img.png"),
      closeImg: require("../../assets/index/close_img.png"),
      shareImg: require("../../assets/index/share_img.png"),
      cloudImg: require("../../assets/index/cloud_img.png"),
      mailImg: require("../../assets/index/mail.png"),
      speaech: '',
      showSpeecher: true,
      speechPause: false,
      speechValue: '',
      showDetailPopup:false,
      flow: 0,
      audioLink: '',
      showMailPop: false, //展示邮件弹窗
      reqDocId: '',
      mailPattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/,
      mailText: '',
      errMsg: {
        mailText: ''
      }
    }
  },
  components: {
    Login,
    UploadFile,
    Speecher
  },
  created() {
    localStorage.setItem("strdocid", this.$route.query.strdocid)
    this.templogin()
  },
  computed: {
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    userId() {
      return this.$store.state.user.userId;
    },
    activeName() {
      return this.$store.state.commonSearchData.activeName;
    },
    fixedDir() {
      return this.$store.state.fixedFolder.fixedFolderArr;
    },
    shareTypeVal() {
      if (this.shareType === 1) {
        return '👮最新政策发布'
      } else if (this.shareType === 2) {
        return '👮税收优惠政策'
      } else if (this.shareType === 3) {
        return '👮官方解答'
      } else if (this.shareType === 4) {
        return '👮涉税判例'
      } else {
        return '👮税收政策法规'
      }
    }
  },
  methods: {
    // 获取当前文件的语音链接
    getAudioLink(strId){
      this.$http.ReqGetTTs(strId).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            console.log("link888", res.item.signedurl);
            this.audioLink = res.item.signedurl
            this.flow = res.item.filesize
            this.speechPause = false
          } else if(res.rltcode === -160) {
            this.audioLink = ''
          }
        }
      });
    },
    playAudio(){
      if(this.audioLink) {
        this.$refs.speech.isPlaying = true
        this.speechPause = false
        this.$notify({
        color: "#fff",
        background: "#49d68c",
        message: `将使用${(this.flow/1024/1024).toFixed(2)}MB流量`,
        duration: 3000,
        });
        var audio = document.getElementById('video-player');
        audio.play()
        audio.addEventListener('ended', () => {
          this.speechPause = true
        })
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: '该文件语音正在生成中，请稍后再试',
          duration: 5000,
        })
        return false
      }
    },
    pauseAudio() {
      if (this.speechPause) {
        document.getElementById('video-player').play()
        this.speechPause = false
      } else {
        document.getElementById('video-player').pause()
        this.speechPause = true
      }
    },
    resetAudio() {
      this.$refs.speech.isPlaying = false
      var audio = document.getElementById('video-player');
      audio.currentTime = 0
      audio.pause()
    },
    // 确认发送邮件
    sureSendMail() {
      let strId = this.reqDocId; 
      //console.log("xxx", strId);
      if(!this.mailPattern.test(this.mailText)) {
        this.errMsg.mailText = "邮箱输入有误，请重新输入";
        return false;
      } else {
        this.errMsg.mailText = "";
        this.$http.reqSendMail({
           strdocid: strId,
           email: this.mailText
         }).then((res) => {
           if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.$notify({
                color: "#fff",
                background: "#49d68c",
                message: '邮件发送成功',
                duration: 3000,
              })
              this.showMailPop = false
             }
           }
         })
      }
    },
    shareBtn() {
      this.getShareLink()
    },
    // 获取分享链接
    getShareLink() {
      let bodyJson = {
        docid: this.$route.query.strdocid
      };
      this.$http.reqGetShareUrl(bodyJson).then((res) => {
        this.shareLink = res.item.url

        if(this.shareLink) {
          window.location.href = this.shareLink
          localStorage.setItem("shareWay",1)
          window.localStorage.removeItem("docFiresArr")
        }
      });
    },
    // 临时登录
    templogin () {
      this.$http.reqTempLogin().then((resp) => {
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            this.$store.commit("user/setUserId", resp.userid);
            this.$store.commit("user/setUserGuid", resp.userguid);
            this.$store.commit("user/setRealName", resp.realname);
            this.$store.commit("user/setToken", resp.token);
            this.$store.commit("user/setMobileNum", resp.mobilenum);
            this.$store.commit("user/setAccountType", resp.accounttype);
            this.$store.commit("user/setPermission", resp.permission);
            this.$store.commit("user/setAccountStatus", resp.accountstatus);
            this.$store.commit("user/setShowMsg", resp.showmsg);
            this.$store.commit("user/setMaxOpenNum", resp.maxopendocnum)
            this.$store.commit("user/setOpenNum", resp.opendocnum)
            this.$store.commit("user/setMaxToken", resp.maxtokens)
            this.$store.commit("user/setMallVer", resp.mallver)
            localStorage.setItem("userguid", resp.userguid)
            sessionStorage.setItem("token", resp.token)
            if (resp.permission != null && resp.permission.length > 0) {
              let items = [];
              resp.permission.forEach((item) => {
                items.push(item.f);
              });
              this.$store.commit("user/setPermissionArray", items);
            }
            this.wxAuto()
          }
        }
      });
    },
    // 微信授权
    wxAuto() {
      if(getUrlParam(location.search, 'code')) {
        this.wxLogin()
      } else {
        let req = {
        http_redirct: fileInfoUrl+"?strdocid="+localStorage.getItem("strdocid")
        };
        this.$http
          .reqPostGetWeixinPromise(req)
          .then((res) => {
            if (res.rtncode === 1 && res.rltcode === 1) {
              console.log('yyu',res.item.url)
              window.location.href = res.item.url
            }
          })
          .catch((err) => {
            commonDialog(err.message, this);
          });
      }
    },
    // 微信注册
    wxLogin () {
      let obj = searchToObj(location.search);
      obj.tempuserguid = localStorage.getItem("userguid");
      let newObj = {
        code: obj.code,
        state: obj.state,
        tempuserguid: obj.tempuserguid,
      };
      this.$http
        .reqPostWeixinRegLogin(newObj)
        .then((resp) => {
          console.log("fileinfo====>", resp)
          // this.$http.refreshToken().then((res) => {
            this.bus.$emit("saveTokenHandle", resp, 1)
            this.showUpload = true
            this.getDetail(this.$route.query.strdocid)
          // });
          this.getFixedFolder()
        })
        .catch((err) => {
          commonDialog(err.message, this);
        });
    },
    // 更新doc文件的内容
    updateDoc() {
      if (this.backDocFiresArr.length > 1) {
        this.getDetail1(this.$route.query.strdocid);
      } else {
        this.getDetail(this.$route.query.strdocid);
      }
    },
    // 请登录查看全文 按钮
    login() {
      this.$refs.alertModel.changeShowLogin(true);
    },
    // 返回按钮
    backToLastFire() {
      this.resetAudio()
      if(this.lastFlag) {
        return
      }
      this.addid = false
      this.$nextTick(() => {
        let dom = document.getElementById("moreMerchant");
        dom.scrollIntoView();
      })
      if (this.backDocFiresArr.length > 1) {
        this.backDocFiresArr.pop()
        console.log("返回按钮this.backDocFiresAr", this.backDocFiresArr);
        let lastId = this.backDocFiresArr.slice(-1)
        // console.log("lastIdlastId", lastId)
        this.getDetail1(lastId[0])
        if (this.backDocFiresArr.length === 1) {
          this.lastFlag = true
        }
        this.$http.reqCloseDoc(lastId).then((res) => {
          console.log("guanbiwenjianjia", res);
        });
      } else {
        // 只有一个id
        this.getDetail1(this.backDocFiresArr[0])
        this.lastFlag = true
      }
    },
    getDetail1(docid) {
      this.showLoding = true
      let bodyJson = {
        strdocid: docid,
        docid: "",
        h1hit: [],
        chit: [],
        chitseq: [],
        cutwords: [],
      };
      this.$http
        .reqPostDocDetail(bodyJson)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.reqDocId = response.item.strdocid

              this.handleLoadDoc(response)
              this.getAudioLink(response.item.strdocid)
              // this.headers = response.item.headers
              // let tempdata = base.b64_to_utf8(response.item.body)
              // this.value = tempdata.replace(/\r?\n/g, "<br />")
              this.uploadDocId[0] = response.item.docid
            } else {
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: response.rltdesc,
                duration: 5000,
              });
              this.showLoding = false;
            }
            if (this.accountstatus < 200) {
              // 该文件需要购买会员
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: "要获得普通下载权限,请前去在线商城购买账号等级",
                duration: 5000,
              });
              this.showLoding = false;
              return;
            }
            if (response.rltcode === -300) {
              // 该文件需要下载才能访问，请请求下载接口
              //message: "该文件暂时无法访问，请阅览其他文件！",
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: "请登录电脑端下载该附件!   网址：www.holywiser.com",
                duration: 5000,
              });
              this.showLoding = false
            }
          } else {
            this.showLoding = false
          }
        })
        .catch(() => {
          this.showLoding = false
        });
    },
    // 查看文件时显示 点击登录按钮
    handleLoadDoc(response) {
      if (response.rtncode === 1) {
        if (response.rltcode === 1) {
          // ++
          //this.getShareLink()
          // ++
          this.shareType = response.item.sharetype
          this.shareScene =  response.item.scene
          localStorage.setItem('shareScene', this.shareScene)
          localStorage.setItem('shareTypeVal', this.shareTypeVal)
          this.shareTitle = response.item.doctitle
          if(this.shareType != 4) {
            localStorage.setItem('shareTitle', this.shareTitle)
          }
          if (this.addid) {
            this.backDocFiresArr.push(response.item.strdocid)
            console.log("this.backDocFiresArrrrrrr", this.backDocFiresArr)
            if (this.backDocFiresArr.length > 1) {
              this.lastFlag = false
            } else {
              this.lastFlag = true
            }
          }
          this.showLoding = false
          this.headers = response.item.headers
          let tempdata = base.b64_to_utf8(response.item.body)
          this.value = tempdata.replace(/\r?\n/g, "<br />")
          this.speechValue = tempdata.replace(/<[^>]+>/g, '')
          if (response.item.hidden === true) {
            // true：临时登录  false：已登录
            this.showLoginBtn = true;
          }
        } else {
          this.$notify({
            color: "#fff",
            background: "#F27852",
            message: response.rltdesc,
            duration: 5000
          });
          this.showLoding = false
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: response.rtndesc,
          duration: 5000
        });
        this.showLoding = false
      }
    },
    // 关闭按钮
    backToMail() {
      this.resetAudio()
      this.addid = true;
      new Promise((resolve, reject) => {
        this.getLocation(resolve);
      }).then(() => {
        let reqDocFiresArr = this.backDocFiresArr.concat([]);
        this.$http.reqCloseDoc(reqDocFiresArr).then((res) => {
          this.$router.push('newFiles')
        })
        this.backDocFiresArr = []
      });
      
    },
    // 点击链接
    openLink (value) {
      this.resetAudio()
      if (value.srcElement.id) {
        this.addid = true
        this.showLoding = true
        this.$nextTick(() => {
          let dom = document.getElementById("moreMerchant")
          dom.scrollIntoView()
        })
        this.strId = value.srcElement.id
        this.getDetail1(value.srcElement.id)
      } else if (value.srcElement.tagName === "TT") {
        this.$nextTick(() => {
          let dom = document.getElementById(value.srcElement.lang)
          dom.scrollIntoView()
        })
        this.showLoding = false
      }
    },
    // 获取最新文件列表
    getDetail(strId) {
      let bodyJson = {
        strdocid: strId,
        docid: "",
        h1hit: [],
        chit: [],
        chitseq: [],
        cutwords: [],
      }
      this.$http
        .reqPostDocDetail(bodyJson)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.showDetailPopup = true
              this.reqDocId = response.item.strdocid

              this.getAudioLink(response.item.strdocid)
              this.handleLoadDoc(response)
              this.uploadDocId[0] = response.item.docid
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
              this.$dialog.confirm({
                message: "当前您无权限访问,是否返回首页",
                showCancelButton: false
              }).then(() => {
                this.$router.push("/index")
              });
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          sessionStorage.clear();
          this.$cookie.delete("cookieObj");
          this.showLoding = false;
        });
    },
    // 获取云端固定文件夹
    getFixedFolder() {
      this.$http.reqGetFixedFolder().then((response) => {
        if (response.rtncode === 1) {
          if (response.rltcode === 1) {
            console.log("成功后获取固定文件夹", response);
            this.$store.dispatch(
              "fixedFolder/updateFixedFolderArr",
              response.item
            );
            localStorage.setItem(
              "fixedFolderArr",
              JSON.stringify(response.item)
            );
          }
        }
      });
    },
    // 上传云端按钮
    uploadToSmartCloud() {
      if (this.userId) {
        this.$refs.uploadFile.updateOrDelete(1, '上传云端')
        console.log("直接上传的id", this.uploadDocId, this.fixedDir[0].dir_id);
      } else {
        // 提示登录后使用
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请您先登录再使用[上传云端]功能",
          duration: 5000
        });
      }
    },
    // 调用微信的SDK
    getLocation(resolve) {
        // 微信浏览器
      let reqBody = {
        url: fileInfoUrl,
      };
      this.$http
        .reqGetWxConfig(reqBody)
        .then((res) => {
          new Promise((ok, err) => {
            wxConfig(res, ok, err);
          })
            .catch((err) => console.log(err))
            .finally(() => {
              let x = localStorage.getItem("latitude")
                  ? localStorage.getItem("latitude")
                  : 0,
                y = localStorage.getItem("longitude")
                  ? localStorage.getItem("longitude")
                  : 0;
              getTempLocation(resolve, x, y);
              this.showLoading = false;
            });
        })
        .catch((err) => {
          this.showLoading = false;
        })
        .finally(() => {
          resolve();
        });
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
@--line-color: #DCDEE2;
#file-info {
  .fileElements {
    height: 100%;
    background: #fff;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none; // 重点
    }
    .topLine {
      border-top: 1px solid @--line-color;
    }
    .elements {
      display: flex;
      min-height: 40px;
      border-bottom: 1px solid @--line-color;
      color: #515a6e;
      font-size: 12px;
      border-right: 1px solid @--line-color;
      &:nth-child(odd) {
        background-color: #f8f8f9;
      }
      .title {
        flex: 0 0 27%;
        text-align: center;
        border-left: 1px solid @--line-color;
        border-right: 1px solid @--line-color;
        line-height: 40px;
      }
      .content {
        flex: 1;
        text-align: center;
        margin: auto 0;
      }
    }
    .docContent {
      margin-bottom: 60px;
    }
  }
  .share-btn {
    width: 3rem;
    border-radius: 30px;
    height: 40px;
    border-color: #00A7FA;
    background: linear-gradient(to right, #00A9FF, #0080FF);
    color: #ffffff;
  }
  .backStyle {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .oprate-box {
    padding:5px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .no-return {
      color: #999999;
    }
  }
  .backStyle {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
  }
  .loginBtn {
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: -300px;
    background: rgba(255, 255, 255, 0.9);
  }
  /deep/.van-loading {
    display: flex;
    justify-content: center;
    margin-top: 10%;
  }
  .send-mail-wapper {
    padding: 0 20px;
    .mail-box {
      margin: 20px 0 30px 0;
      /deep/.van-cell {
        border-bottom:1px solid #F0F0F0;
        padding-left: 0px;
      }
      
    }
  }
  /deep/.van-popup__close-icon {
    color: #000;
  }
}
</style>

<style lang="less">
@import "~@/styles/article.less";
</style>
